import { createFileRoute } from '@tanstack/react-router';

import { SubscriptionsListPage } from '@/pages/subscriptions/subscriptions-list-page';

export const Route = createFileRoute('/subscriptions/')({
  component: SubscriptionsListPage,
});
